<tabset #staticTabs>
    <tab heading="General Info">
      <ng-content select=".General Info">
      </ng-content>
      <div  class="General">
      <h3>{{'DeclineinValue.PageTitle'|translate}}</h3>

        <div class="row m-0">

          <p>{{'DeclineinValue.Ifyoubelieve'|translate}}</p>

          <!-- <p><strong>{{'DeclineinValue.The'|translate}}{{date}}{{'DeclineinValue.DivFilingperiod'|translate}}{{'July 2, ' + date + ' through November 30, ' + date}}.</strong></p> -->
            <!-- {{'DeclineinValue.Applications'|translate}}{{'July 2, ' + date}}.</strong></p> -->
          <p [innerHTML]="'DeclineinValue.DIVOpenAnnual'|translate"></p>
          <p [innerHTML]="'DeclineinValue.DIVNote'|translate"></p>
          <p>{{'DeclineinValue.California'|translate}}</p>
          <p>{{'DeclineinValue.in1978v2'|translate}}</p>
          <!-- <p>{{'DeclineinValue.Theofficeofv2'|translate}}</p> -->
          <p>{{'DeclineinValue.Itisimportant'|translate}}</p>
        </div>
<!--
        <div class="column2">
          <button type="button" class="btn btn-primary">About My Decline-in-Value Notice</button>
          <br><br>
          <button type="button" class="btn btn-primary">My Decline-in-Value Review Status</button>
          <br><br>
          <button type="button" class="btn btn-primary">About this Process</button>
          <br><br>
        </div> -->

      </div>

      <div class="General">


      <accordion [isAnimated]="true">

        <accordion-group #drop [isOpen]="drop">
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Eligibility'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

            <p>{{'DeclineinValue.Youmustdemonstrate'|translate}}</p>
            <p>{{'DeclineinValue.Youmustfile'|translate}} <b>(RP-87)</b> {{'DeclineinValue.withthe'|translate}}</p>


      </accordion-group>
      <accordion-group #drop2>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Theprocess'|translate}} <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

            <p [innerHTML]="'DeclineinValue.Onyourclaim'|translate"></p>
            <p>{{'DeclineinValue.AnAppraiser'|translate}}</p>
            <p>{{'DeclineinValue.Ifthecurrent'|translate}}</p>
            <p>{{'DeclineinValue.Ifyoudisagree'|translate}}</p>
            <p class="mb-0"><strong>{{'DeclineinValue.Example'|translate}}</strong></p>
            <p>{{'DeclineinValue.Apropertyv2'|translate}}</p>

          <table>
            <tr>
              <th>Year</th>
              <th>Base Value Trended</th>
              <th>Market Value</th>
              <th>Assessed Value</th>
            </tr>
            <tr>
              <td>Year 1</td>
              <td>$500,000</td>
              <td>$500,000</td>
              <td>$500,000</td>
            </tr>
            <tr>
              <td>Year 2</td>
              <td>$510,000</td>
              <td>$480,000</td>
              <td>$480,000</td>
            </tr>
            <tr>
              <td>Year 3</td>
              <td>$520,200</td>
              <td>$510,000</td>
              <td>$510,000</td>
            </tr>
            <tr>
              <td>Year 4</td>
              <td>$530,604</td>
              <td>$550,000</td>
              <td>$530,604</td>
            </tr>
          </table>
      </accordion-group>
      <!-- <accordion-group #drop3>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Informationv2'|translate}} <i class="mt-1 float-end" [ngClass]="!drop3.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>

            <p>{{'DeclineinValue.Ifyoureceivedv2'|translate}}</p>
            <p [innerHTML]="'DeclineinValue.Ifyoubelievemarketv2'|translate"></p>



      </accordion-group> -->

      </accordion>
      </div>

    <!--</div>-->
    </tab>
    <tab heading="FAQ" (selectTab)="onSelect($event);">
      <div class="faq_tab" *ngFor="let item of FaqData">
        <h5 [innerHTML]="item.question"></h5>
        <p [innerHTML]="item.answer"></p>
      </div>
    </tab>

    <!-- <tab  heading="Forms" class="forms_tab" (selectTab)="onSelect($event)"> -->
      <!-- <p [innerHTML]="'DeclineinValue.Forms'|translate"></p> -->
       <!-- <div class="list-group" *ngFor="let item of FormData">
        <a href="{{item.fileUrl}}" target="_blank" class="list-group-item-action">
          <div class="row">
            <div class="col-2 img_container">
              <img src="../../../assets/pdf_icon.svg" alt="">
            </div>
            <div class="col-10">
              <h5>{{item.formNumber}}</h5>
              <p >{{item.title}}</p>
            </div>
          </div>
        </a>
      </div>
    </tab> -->


    <!-- DO NOT SHOW -->
      <!-- <tab heading="Notice">
      <ng-content select=".notice">
      </ng-content>
      <div class="General">

          <h3>{{'DeclineinValue.Informationon2021DIV'|translate}}</h3>
          <p>{{'DeclineinValue.Ifyoureceivedanotice'|translate}}</p>
          <p>{{'DeclineinValue.Ifyoubelievethe'|translate}}</p>

      </div>
    </tab> -->


    <tab heading="Status">
      <ng-content select=".status">
      </ng-content>
      <div class="General">
          <h3>{{'DeclineinValue.MyDIVReviewStatus'|translate}}</h3>
          <p [innerHTML]="'DeclineinValue.Whileyoumayv4'|translate"></p>
          <iframe src="https://assessorapp.lacounty.gov/Prop8Status.aspx" width="800" height="900"></iframe>
        </div>
    </tab>

    <!-- ------------Show for DIV Season------------------- -->

    <!-- <tab heading="Application">
      <ng-content select=".application">
      </ng-content>
      <div class="General"> -->

          <!-- <p *ngIf="isChrome">This is in chrome</p> -->
          <!-- <p>{{ name_browser | titlecase }}</p> -->

          <!-- <h3>{{'DeclineinValue.DIVapp'|translate}}</h3>
          <p>{{'DeclineinValue.Pleasebeadvised'|translate}}</p>
          <p>{{'DeclineinValue.Ifyoudont'|translate}}</p>
          500 West Temple Street Room 286<br>
          Los Angeles CA, 90012-2770<br>
          <br>
          <div>
            <strong  [innerHTML]="'DeclineinValue.Chromeusers'|translate"></strong><br>
            <a type="button" class="btn btn-primary" href="https://ASSESSOR.CO.LA.CA.US/extranet/OnlineFiling/divhome.aspx" target="_blank">{{'DeclineinValue.FileApplication'|translate}}</a>
          </div>

          <br><br>
            <iframe *ngIf="!isChrome" src="https://ASSESSOR.CO.LA.CA.US/extranet/OnlineFiling/divhome.aspx" width="800px" height="900"><span data-mce-type="bookmark" style="display: inline-block; width: 0px; overflow: hidden; line-height: 0;" class="mce_SELRES_start">﻿</span>
          </iframe>
        </div>
    </tab>


  </tabset> -->








<!--
<app-leveltwo [pageName]="'Decline In Value/ Property Tax Relief'">
    <div heading="General Info" class="General">
      <h3>{{'DeclineinValue.PageTitle'|translate}}</h3>

      <div class="row">
        <div class="column1">
          <p>{{'DeclineinValue.Ifyoubelieve'|translate}}</p>
          <p>{{'DeclineinValue.The2020'|translate}}</p>
          <p>{{'DeclineinValue.California'|translate}}</p>
          <p>{{'DeclineinValue.in1978'|translate}}</p>
          <p>{{'DeclineinValue.Ovethepast'|translate}}</p>
          <p>{{'DeclineinValue.However'|translate}}</p>
        </div>
        <div class="column2">
          <button type="button" class="btn btn-primary">About My Decline-in-Value Notice</button>
          <br><br>
          <button type="button" class="btn btn-primary">My Decline-in-Value Review Status</button>
          <br><br>
          <button type="button" class="btn btn-primary">About this Process</button>
          <br><br>
        </div>
      </div>



      <accordion [isAnimated]="true">

        <accordion-group #drop>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Eligibility'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
      <h4>{{'DeclineinValue.Eligibility'|translate}}</h4>
            <p>{{'DeclineinValue.Youmustdemonstrate'|translate}}</p>
            <p>{{'DeclineinValue.Youmustfile'|translate}}</p>


      </accordion-group>
      <accordion-group #drop2>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Theprocess'|translate}} <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
      <h4>{{'DeclineinValue.Theprocess'|translate}}</h4>
            <p>{{'DeclineinValue.Onyourclaim'|translate}}</p>
            <p>{{'DeclineinValue.AnAppraiser'|translate}}</p>
            <p>{{'DeclineinValue.Ifthecurrent'|translate}}</p>
            <p>{{'DeclineinValue.Ifyoudisagree'|translate}}</p>
            <p>{{'DeclineinValue.Example'|translate}}</p>
            <p>{{'DeclineinValue.Aproperty'|translate}}</p>

          <table>
            <tr>
              <th>Year</th>
              <th>Base Value Trended</th>
              <th>Market Value</th>
              <th>Assessed Value</th>
            </tr>
            <tr>
              <td>Year 1</td>
              <td>$500,000</td>
              <td>$500,000</td>
              <td>$500,000</td>
            </tr>
            <tr>
              <td>Year 2</td>
              <td>$510,000</td>
              <td>$480,000</td>
              <td>$480,000</td>
            </tr>
            <tr>
              <td>Year 3</td>
              <td>$520,200</td>
              <td>$510,000</td>
              <td>$510,000</td>
            </tr>
            <tr>
              <td>Year 4</td>
              <td>$530,604</td>
              <td>$550,000</td>
              <td>$530,604</td>
            </tr>
          </table>
      </accordion-group>
      <accordion-group #drop>
        <div accordion-heading >
          <span class="dropdown-item clearfix">
            {{'DeclineinValue.Information'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
          </span>
        </div>
      <h4>{{'DeclineinValue.Information'|translate}}</h4>
            <p>{{'DeclineinValue.Ifyoureceived'|translate}}</p>
            <p stye="color:red"><b><u>{{'DeclineinValue.Note'|translate}}</u></b>:{{'DeclineinValue.Ifyoubelievemarket'|translate}}<b>{{'DeclineinValue.July1'|translate}}</b></p>
            <p>{{'DeclineinValue.Pleaseclick'|translate}} <a href="https://www.boe.ca.gov/info/assessmentvideo/">{{'DeclineinValue.here'|translate}}</a> {{'DeclineinValue.forinformation'|translate}}</p>


      </accordion-group>

      </accordion>

    </div>

</app-leveltwo>
-->
